import styled from 'styled-components';

const cards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const Wrapper = {
  Cards: cards,
};

export default Wrapper;
